import Qs from 'qs';
import Cookies from 'js-cookie';

export const CookieApi = Cookies.withAttributes({ domain: location.hostname, expires: 30 });

/**
 * 平台类型映射表
 * 1: 管家端, 2: 商家端, 3: 社区端
 */
const APP_TYPE_MAP = {
  1: 'housekeeperApp',
  2: 'houseMerchantApp',
  3: 'communityApp'
};

/**
 * 常量
 */
let platType;
let redirect;

// 先解析 URL 参数，即使没有 location.search 也初始化为空对象，防止后续报错
let searchObj = {};
if (location.search) {
  searchObj = Qs.parse(location.search, { ignoreQueryPrefix: true });
}

if (searchObj.redirect) {
  redirect = searchObj.redirect;
  localStorage.setItem('redirect', searchObj.redirect);
} else {
  redirect = localStorage.getItem('redirect');
}

// 优先获取 URL 中的 appType 或 platType，如果没有再看缓存
let rawType = searchObj.appType || searchObj.platType;

if (rawType) {
  platType = APP_TYPE_MAP[rawType] || rawType;

  localStorage.setItem('platType', platType);
} else {
  platType = localStorage.getItem('platType');
}

if (location.pathname.indexOf('applogin') > -1 || location.pathname.indexOf('/account/userLogin/hwCallback') > -1) {
  if (!platType) {
    platType = 'housekeeperApp';
  }
}

export const APP_ID = platType || 'acsecurity'; // appId
export const APP_SECRET = platType || 'acsecurity'; // appSecret
export const PLAT_TYPE = platType || 'acsecurity'; // 平台类型可能的值：用户中心后台、社区、物业、政务
export const FROM_OS = 3; //  注册平台 1:IOS，2:Android，3:web
export const redirectUrl = redirect;

console.log('redirect: ', redirectUrl);
console.log('platType22: ', PLAT_TYPE);
